// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Registration.css */

.main-registration-container {
  background: linear-gradient(240deg, #038cf4, #79c6e9);
  /* height: 172.5vh; */
  height: auto;
}

.registration-container {
  width: 100%;
  height: 100%;
  max-width: 40%; /* Container takes up 40% width for larger screens */
  margin: 0 auto; /* Center the container */
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Soft shadow */
  animation: fadeIn 0.5s ease-in-out; /* Smooth entry animation */
  box-sizing: border-box;
  
   /* Ensure padding is included in element's width */
}

/* Media Query for screens smaller than 600px */
@media (max-width: 600px) {
  .registration-container {
    width: 100%;          /* Full width on smaller screens */
    max-width: 100%;      /* Remove max-width constraint */
    margin: 0;            /* Remove margin to prevent overflow */
    padding: 15px;        /* Adjust padding for smaller screens */
    box-sizing: border-box; /* Ensure padding is included in the element's width */
    overflow-x: hidden;   /* Prevent horizontal overflow */
  }
}
/* Media Query for Screens smaller than 1200px */
@media (max-width: 1200px) {
  .registration-container {
    width: 100%;          /* Full width on smaller screens */
    max-width: 100%;      /* Remove max-width constraint */
    margin: 0;            /* Remove margin to prevent overflow */
    padding: 30px;        /* Adjust padding for smaller screens */
    box-sizing: border-box; /* Ensure padding is included in the element's width */
    overflow-x: hidden; 
    
  }
}

/* Smooth fade-in animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-wrapper {
  padding: 20px;
  padding-top: 0px;
  /* max-height: 70vh;
    overflow-y: auto; */
}

.title {
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.label {
  font-size: 1em;
  color: #555;
  margin-bottom: 5px;
}

.input,
.inputEmail,
.button {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1em;
  transition: border-color 0.3s;
}

.input:focus,
.inputEmail:focus {
  border-color: #07a6ef; /* Blue border on focus */
  outline: none;
}

.button {
  background-color: #07a6ef;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

.button:hover {
  background-color: #07a6ef;
}

.button:disabled {
  background-color: #aaa; /* Grey button when disabled */
  cursor: not-allowed;
}

.button:disabled:hover {
  background-color: #aaa; /* Grey button when disabled */
  cursor: not-allowed;
}

.email-otp-group {
  display: flex;
  gap: 10px;
}

.email-otp-group .inputEmail {
  flex: 2 1;
}

/* .email-otp-group .OTPbutton {
  flex: 1;
} */

.OTPbutton {
  background-color: #07a6ef;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  padding: 3px;
  border-radius: 5px;
  height: 33px;
}

.OTPbutton:hover {
  background-color: #07a6ef;
}

.OTPbutton:disabled {
  background-color: #aaa; /* Grey OTPbutton when disabled */
  cursor: not-allowed;
}

.input-disabled-register{
  background-color: #f5f5f5;
  color: #a0a0a0;
  cursor: not-allowed;
}

/* Success and error messages */
.error-message,
.success-message {
  font-size: 0.9em;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

.error-message {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.success-message {
  color: #07a6ef;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.form-wrapper h3 {
  font-size: 2rem;
  margin-bottom: 20px;
  text-align: left;
}

.registration-additional-links {
  margin-top: 20px;
  font-weight: 600;
  font-size: 17px;
  text-align: center;
}

.registration-additional-links a {
  margin-right: 10px;
  color: #333;
  text-decoration: none;
  color: #07a6ef;
  align-items: left;
}

/* .registration-additional-links a:hover {
    text-decoration: underline;
  } */

.noteHere {
  font-size: 12px;
  text-align: center;
  margin-top: -10px;
}

.modal-container {
  background-color: white; /* White background */
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
  width: 80%;
  text-align: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for the modal */
}

.modal-container h2 {
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
  margin-top: -10px;
}

.option-tiles {
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 10px; /* Space between tiles */
}

/* Style each option button to look like a planTile */
.planTile {
  background-color: #f4f4f4; /* Light gray background for tiles */
  padding: 15px;
  border-radius: 8px;
  border: none;
  text-align: center;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: auto;
  height: auto;
}

/* Hover effect for tiles */
.planTile:hover {
  background-color: #e0e0e0;
}

.tileButton:hover {
  background-color: #559954;
}

.MuiModal-root {
  display: flex;
  justify-content: center;
  align-items: center;
}

.plan-description {
  list-style-type: disc;
  padding-left: 20px;
  text-align: left; /* Align the description to the left */
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

/* Responsive for smaller screens */
@media (max-width: 600px) {
  .option-tiles {
    grid-template-columns: 1fr 1fr; /* 2 columns on smaller screens */
  }
}
@media (max-width: 1200px) {
  .option-tiles {
    grid-template-columns: 2fr 1fr; /* 2 columns on smaller screens */
  }
}

`, "",{"version":3,"sources":["webpack://./src/Css/Registration.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,qDAAqD;EACrD,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,oDAAoD;EACpE,cAAc,EAAE,yBAAyB;EACzC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC,EAAE,gBAAgB;EAC1D,kCAAkC,EAAE,2BAA2B;EAC/D,sBAAsB;;GAErB,kDAAkD;AACrD;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW,WAAW,kCAAkC;IACxD,eAAe,OAAO,gCAAgC;IACtD,SAAS,aAAa,sCAAsC;IAC5D,aAAa,SAAS,uCAAuC;IAC7D,sBAAsB,EAAE,sDAAsD;IAC9E,kBAAkB,IAAI,gCAAgC;EACxD;AACF;AACA,gDAAgD;AAChD;EACE;IACE,WAAW,WAAW,kCAAkC;IACxD,eAAe,OAAO,gCAAgC;IACtD,SAAS,aAAa,sCAAsC;IAC5D,aAAa,SAAS,uCAAuC;IAC7D,sBAAsB,EAAE,sDAAsD;IAC9E,kBAAkB;;EAEpB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB;uBACqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB,EAAE,yBAAyB;EAChD,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB,EAAE,8BAA8B;EACtD,mBAAmB;AACrB;;AAEA;EACE,sBAAsB,EAAE,8BAA8B;EACtD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;KAEK;;AAEL;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB,EAAE,qBAAqB;EAC9C,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,0CAA0C,EAAE,gCAAgC;AAC9E;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS,EAAE,wBAAwB;AACrC;;AAEA,qDAAqD;AACrD;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB,EAAE,sCAAsC;EACxD,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,8BAA8B,EAAE,iCAAiC;EACnE;AACF;AACA;EACE;IACE,8BAA8B,EAAE,iCAAiC;EACnE;AACF","sourcesContent":["/* Registration.css */\r\n\r\n.main-registration-container {\r\n  background: linear-gradient(240deg, #038cf4, #79c6e9);\r\n  /* height: 172.5vh; */\r\n  height: auto;\r\n}\r\n\r\n.registration-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  max-width: 40%; /* Container takes up 40% width for larger screens */\r\n  margin: 0 auto; /* Center the container */\r\n  padding: 20px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Soft shadow */\r\n  animation: fadeIn 0.5s ease-in-out; /* Smooth entry animation */\r\n  box-sizing: border-box;\r\n  \r\n   /* Ensure padding is included in element's width */\r\n}\r\n\r\n/* Media Query for screens smaller than 600px */\r\n@media (max-width: 600px) {\r\n  .registration-container {\r\n    width: 100%;          /* Full width on smaller screens */\r\n    max-width: 100%;      /* Remove max-width constraint */\r\n    margin: 0;            /* Remove margin to prevent overflow */\r\n    padding: 15px;        /* Adjust padding for smaller screens */\r\n    box-sizing: border-box; /* Ensure padding is included in the element's width */\r\n    overflow-x: hidden;   /* Prevent horizontal overflow */\r\n  }\r\n}\r\n/* Media Query for Screens smaller than 1200px */\r\n@media (max-width: 1200px) {\r\n  .registration-container {\r\n    width: 100%;          /* Full width on smaller screens */\r\n    max-width: 100%;      /* Remove max-width constraint */\r\n    margin: 0;            /* Remove margin to prevent overflow */\r\n    padding: 30px;        /* Adjust padding for smaller screens */\r\n    box-sizing: border-box; /* Ensure padding is included in the element's width */\r\n    overflow-x: hidden; \r\n    \r\n  }\r\n}\r\n\r\n/* Smooth fade-in animation */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.form-wrapper {\r\n  padding: 20px;\r\n  padding-top: 0px;\r\n  /* max-height: 70vh;\r\n    overflow-y: auto; */\r\n}\r\n\r\n.title {\r\n  font-size: 1.8em;\r\n  font-weight: bold;\r\n  margin-bottom: 20px;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.label {\r\n  font-size: 1em;\r\n  color: #555;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.input,\r\n.inputEmail,\r\n.button {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  font-size: 1em;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.input:focus,\r\n.inputEmail:focus {\r\n  border-color: #07a6ef; /* Blue border on focus */\r\n  outline: none;\r\n}\r\n\r\n.button {\r\n  background-color: #07a6ef;\r\n  color: white;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.button:hover {\r\n  background-color: #07a6ef;\r\n}\r\n\r\n.button:disabled {\r\n  background-color: #aaa; /* Grey button when disabled */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.button:disabled:hover {\r\n  background-color: #aaa; /* Grey button when disabled */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.email-otp-group {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.email-otp-group .inputEmail {\r\n  flex: 2;\r\n}\r\n\r\n/* .email-otp-group .OTPbutton {\r\n  flex: 1;\r\n} */\r\n\r\n.OTPbutton {\r\n  background-color: #07a6ef;\r\n  color: white;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n  padding: 3px;\r\n  border-radius: 5px;\r\n  height: 33px;\r\n}\r\n\r\n.OTPbutton:hover {\r\n  background-color: #07a6ef;\r\n}\r\n\r\n.OTPbutton:disabled {\r\n  background-color: #aaa; /* Grey OTPbutton when disabled */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.input-disabled-register{\r\n  background-color: #f5f5f5;\r\n  color: #a0a0a0;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Success and error messages */\r\n.error-message,\r\n.success-message {\r\n  font-size: 0.9em;\r\n  margin-bottom: 15px;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n.error-message {\r\n  color: #721c24;\r\n  background-color: #f8d7da;\r\n  border-color: #f5c6cb;\r\n}\r\n\r\n.success-message {\r\n  color: #07a6ef;\r\n  background-color: #d4edda;\r\n  border-color: #c3e6cb;\r\n}\r\n\r\n.form-wrapper h3 {\r\n  font-size: 2rem;\r\n  margin-bottom: 20px;\r\n  text-align: left;\r\n}\r\n\r\n.registration-additional-links {\r\n  margin-top: 20px;\r\n  font-weight: 600;\r\n  font-size: 17px;\r\n  text-align: center;\r\n}\r\n\r\n.registration-additional-links a {\r\n  margin-right: 10px;\r\n  color: #333;\r\n  text-decoration: none;\r\n  color: #07a6ef;\r\n  align-items: left;\r\n}\r\n\r\n/* .registration-additional-links a:hover {\r\n    text-decoration: underline;\r\n  } */\r\n\r\n.noteHere {\r\n  font-size: 12px;\r\n  text-align: center;\r\n  margin-top: -10px;\r\n}\r\n\r\n.modal-container {\r\n  background-color: white; /* White background */\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  max-width: 80%;\r\n  width: 80%;\r\n  text-align: center;\r\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for the modal */\r\n}\r\n\r\n.modal-container h2 {\r\n  margin-bottom: 20px;\r\n  font-size: 24px;\r\n  color: #333;\r\n  margin-top: -10px;\r\n}\r\n\r\n.option-tiles {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr); \r\n  gap: 10px; /* Space between tiles */\r\n}\r\n\r\n/* Style each option button to look like a planTile */\r\n.planTile {\r\n  background-color: #f4f4f4; /* Light gray background for tiles */\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  width: auto;\r\n  height: auto;\r\n}\r\n\r\n/* Hover effect for tiles */\r\n.planTile:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.tileButton:hover {\r\n  background-color: #559954;\r\n}\r\n\r\n.MuiModal-root {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.plan-description {\r\n  list-style-type: disc;\r\n  padding-left: 20px;\r\n  text-align: left; /* Align the description to the left */\r\n  font-size: 14px;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Responsive for smaller screens */\r\n@media (max-width: 600px) {\r\n  .option-tiles {\r\n    grid-template-columns: 1fr 1fr; /* 2 columns on smaller screens */\r\n  }\r\n}\r\n@media (max-width: 1200px) {\r\n  .option-tiles {\r\n    grid-template-columns: 2fr 1fr; /* 2 columns on smaller screens */\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
